module.exports = __webpack_public_path__ + "static/media/story-10.6e8f526b.jpg";